import React, { Component } from 'react';
import Draggable from 'react-draggable';
import EmailSignup from '../All/EmailSignup';
import UpcomingEvent from '../Landing/UpcomingEvent';

class Coming extends Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.state = {
            width: 0,
            resize: false,
            drag: false,
            showDraggable: true
        }
    }

    updateDimensions() {
        this.setState({ drag: false, width: window.innerWidth });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    componentDidMount() {
        this.updateDimensions();
        this.setState({ resize: false });
        window.addEventListener("resize", this.updateDimensions);
    }

    closeDraggable() {
        this.setState({ showDraggable: false })
    }

    eventLogger(e, data) {
        this.setState({ drag: true });
    }

    render() {
        const w = window.innerWidth;
        const defaultMobile = { x: 0, y: 0 };
        const defaultDesktop = this.props.desktopPos;
        const defaultPosition = w < 1024 ? defaultMobile : defaultDesktop;
        const disable = w < 1024 ? true : false;
        const position = this.state.resize === false && this.state.drag === true ? null : defaultPosition;

        return (
            <Draggable
              axis="both"
              handle=".handle"
              disabled={disable}
              defaultPosition={defaultPosition}
              position={position}
              onDrag={this.eventLogger.bind(this)}
              grid={[1, 1]}
              zIndex={2000} >
                <div data={this.state.width}>
                  {this.state.showDraggable && <div className={"handle candrag " + this.props.containerId}>
                      <div className="close" onClick={this.closeDraggable.bind(this)}/>
                      {this.props.containerId === "upcoming" ?
                      <UpcomingEvent event={this.props.event} activeHor={this.props.activeHor} activeVer={this.props.activeVer}/> :
                      <EmailSignup includeName={true} />
                      }
                  </div> }
                </div>
            </Draggable>
        );
    }
}

export default Coming;



// WEBPACK FOOTER //
// ./src/components/other/Popup.js